import React from 'react';
import AbstractComponent from '../../AbstractComponent';
import ContentPesquisa from '../../layout/content/ContentPesquisa';

import FormasPagamentoService from '../../../service/FormasPagamentoService';

import AcaoEnum from '../../../helper/enumerador/AcaoEnum';
import FormCodeEnum from '../../../helper/enumerador/FormCodeEnum';
import TableTypeEnum from '../../layout/table/TableTypeEnum';
import AlignEnum from '../../layout/table/AlignEnum';

class FormasPagamento extends AbstractComponent { 
    constructor(props) {
        super(props);        

        this.state = {            
            head : [
                {nome: 'Descricao', campo: 'descricao', width: '30%'},
                {nome: 'Modalidade de Pagamento', campo: 'modalidade_pagamento.descricao', width: '20%'},
                {nome: 'Qtde de Parcelas', campo: 'qtde_parcelas', width: '20%', align: AlignEnum.RIGHT},
                {nome: 'Compras a partir de', campo: 'compras_a_partir_de', width: '20%', type: TableTypeEnum.MOEDA, align: AlignEnum.RIGHT},
            ],
            
            callBack: {
                id: 1,

                body: [],

                pagination: [],

                recordCount: 0,

                indice: -1,

                mensagem: {
                    message: '',
                    code: 0
                },

                acao: AcaoEnum.NOTHING
            }
        }        
    }        
    
    onRemover(id, i) {    
        FormasPagamentoService.remover(id).then(resposta => {            
            let callBack = this.state.callBack;

            callBack.id++;            
            callBack.mensagem = {
                message: 'Forma de Pagamento excluída com sucesso',
                code: FormCodeEnum.DEFAULT
            };
            callBack.acao = AcaoEnum.REMOVER;
            callBack.indice = i;

            this.setState({ callBack: callBack });
        }).catch(erro => {            
            let callBack = this.state.callBack;

            callBack.id++;            
            callBack.mensagem = this.trataErro(erro);
            callBack.acao = AcaoEnum.ERRO;
            callBack.indice = i;

            this.setState({ callBack: callBack });
        })
    }

    onLoad() {        
        FormasPagamentoService.listar().then(resposta => {            
            let callBack = this.state.callBack;

            callBack.id++;
            callBack.body = resposta.data;
            callBack.mensagem = {
                message: '',
                code: 0
            };
            callBack.acao = AcaoEnum.LOAD;            
            callBack.indice = -1;

            this.setState({ callBack: callBack });            
        }).catch(erro => {
            let callBack = this.state.callBack;
            
            callBack.mensagem = this.trataErro(erro);
            callBack.indice = -1;
            callBack.acao = AcaoEnum.ERRO;

            this.setState({ callBack: callBack });
        })
    }

    render() {
        return (            
            <ContentPesquisa 
                title="Formas de Pagamento"
                
                modalErroMsg={this.state.modalErroMsg}

                head={this.state.head}                     
                
                cadastro={true}
                editar={true}
                remover={true}
                
                link={'configuracao/formas-pagamento'}   
                history=''      
                preload={this.props.preload}                           
                                    
                onLoad={() => this.onLoad()}
                onRemover={(id, i) => this.onRemover(id, i)}
                callBack={this.state.callBack}     
                
                route={(route) => this.props.route(route)}    
            />
        )
    }
}

export default FormasPagamento;